module.exports = __webpack_public_path__ + "static/media/gdpr.14f051ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/threats/4/gdpr.svg
// module id = 370
// module chunks = 0